module.exports = __webpack_public_path__ + "images/136_1024.jpg";